/* Vesper "One jar, three steps" looping animations — minimal ink line style
   VERBATIM from design project 7c2dfc58 (step-animations.js). Deploy as a
   Shopify asset unchanged. Usage: <vesper-step-anim kind="fill|chill|shake"
   bg="#F2E4A8" size="82"></vesper-step-anim> — bg MUST be the resolved hex of
   the disc pastel (the chill scene uses it to paint the fridge door). */
(function () {
  if (customElements.get('vesper-step-anim')) return;
  const INK = '#1C1712', CHERRY = '#B02F2A', BLUE = '#8CB0C4', WINE = '#7E2530', S = 2.4;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const seg = (t, a, b) => clamp((t - a) / (b - a), 0, 1);
  const ez = p => (p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2);
  const G = `fill="none" stroke="${INK}" stroke-width="${S}" stroke-linecap="round" stroke-linejoin="round"`;

  const SCENES = {
    /* 1 — bottle tips in, pours, jar fills */
    fill: {
      dur: 4800,
      svg: () => `
        <clipPath id="jc"><rect x="22.5" y="26" width="19" height="27" rx="3"></rect></clipPath>
        <rect id="liq" x="22.5" y="53" width="19" height="0" fill="${BLUE}" opacity="0.9" clip-path="url(#jc)"></rect>
        <line id="stream" x1="35.5" y1="17.5" x2="34" y2="50" stroke="${BLUE}" stroke-width="2.2" stroke-linecap="round" opacity="0"></line>
        <g ${G}>
          <path d="M21,26 L21,49 Q21,54 26,54 L38,54 Q43,54 43,49 L43,26"></path>
          <line x1="19" y1="26" x2="45" y2="26"></line>
          <g id="bottle">
            <path d="M-1.5,0 L1.5,0 L1.5,4 L4,8 L4,20 Q4,22 2,22 L-2,22 Q-4,22 -4,20 L-4,8 L-1.5,4 Z"></path>
            <line x1="-4" y1="13" x2="4" y2="13"></line>
          </g>
        </g>`,
      ids: ['liq', 'stream', 'bottle'],
      update(r, t) {
        const move = ez(seg(t, 0, 0.14)) - ez(seg(t, 0.66, 0.8));
        const bx = 52 - 16 * move, by = 14 + 2 * move, a = -135 * move;
        r.bottle.setAttribute('transform', `translate(${bx},${by}) rotate(${a})`);
        const h = 18 * ez(seg(t, 0.14, 0.64));
        r.liq.setAttribute('y', 53 - h);
        r.liq.setAttribute('height', h + 1);
        r.liq.setAttribute('opacity', 0.9 * (1 - ez(seg(t, 0.95, 1))));
        r.stream.setAttribute('y2', 52 - h);
        r.stream.setAttribute('opacity', seg(t, 0.12, 0.17) - seg(t, 0.62, 0.67));
      }
    },
    /* 1b — bottle pours heated wine, jar fills, steam rises */
    hotfill: {
      dur: 5000,
      svg: () => `
        <clipPath id="jch"><rect x="22.5" y="26" width="19" height="27" rx="3"></rect></clipPath>
        <rect id="hliq" x="22.5" y="53" width="19" height="0" fill="${WINE}" opacity="0.9" clip-path="url(#jch)"></rect>
        <line id="hstream" x1="35.5" y1="17.5" x2="34" y2="50" stroke="${WINE}" stroke-width="2.2" stroke-linecap="round" opacity="0"></line>
        <g ${G}>
          <path d="M21,26 L21,49 Q21,54 26,54 L38,54 Q43,54 43,49 L43,26"></path>
          <line x1="19" y1="26" x2="45" y2="26"></line>
          <g id="hbottle">
            <path d="M-1.5,0 L1.5,0 L1.5,4 L4,8 L4,20 Q4,22 2,22 L-2,22 Q-4,22 -4,20 L-4,8 L-1.5,4 Z"></path>
            <line x1="-4" y1="13" x2="4" y2="13"></line>
          </g>
          <g id="steam" opacity="0" stroke-width="1.8">
            <path d="M26,23 q2,-2.6 0,-5.2 q-2,-2.6 0,-5.2"></path>
            <path d="M31,24 q2,-2.6 0,-5.2 q-2,-2.6 0,-5.2"></path>
          </g>
        </g>`,
      ids: ['hliq', 'hstream', 'hbottle', 'steam'],
      update(r, t) {
        const move = ez(seg(t, 0, 0.14)) - ez(seg(t, 0.6, 0.74));
        r.hbottle.setAttribute('transform', `translate(${52 - 16 * move},${14 + 2 * move}) rotate(${-135 * move})`);
        const fill = ez(seg(t, 0.14, 0.58)), h = 18 * fill;
        r.hliq.setAttribute('y', 53 - h);
        r.hliq.setAttribute('height', h + 1);
        r.hliq.setAttribute('opacity', 0.9 * (1 - ez(seg(t, 0.95, 1))));
        r.hstream.setAttribute('y2', 52 - h);
        r.hstream.setAttribute('opacity', seg(t, 0.12, 0.17) - seg(t, 0.56, 0.61));
        const sp = seg(t, 0.6, 0.94);
        const wisp = (sp > 0 && sp < 1) ? Math.sin(sp * Math.PI) : 0;
        r.steam.setAttribute('opacity', 0.75 * wisp);
        r.steam.setAttribute('transform', `translate(0,${-4 * sp})`);
      }
    },
    /* 2b — lid closes on the jar, clock hand sweeps one hour */
    wait: {
      dur: 5200,
      svg: () => `
        <clipPath id="jcw"><rect x="20.5" y="30" width="17" height="21" rx="2.6"></rect></clipPath>
        <rect x="20.5" y="39" width="17" height="13" fill="${WINE}" opacity="0.9" clip-path="url(#jcw)"></rect>
        <g ${G}>
          <path d="M19,30 L19,47 Q19,52 24,52 L34,52 Q39,52 39,47 L39,30"></path>
          <line x1="19" y1="30" x2="39" y2="30"></line>
          <g id="lid">
            <rect x="17.5" y="24" width="23" height="5.4" rx="2.4"></rect>
            <rect x="25" y="20.5" width="8" height="3.5" rx="1.6"></rect>
          </g>
          <g id="clock">
            <circle cx="48" cy="17" r="8.5"></circle>
            <line id="hand" x1="48" y1="17" x2="48" y2="11.2" stroke-width="2"></line>
            <circle cx="48" cy="17" r="0.9" fill="${INK}" stroke="none"></circle>
          </g>
        </g>`,
      ids: ['lid', 'clock', 'hand'],
      update(r, t) {
        const drop = ez(seg(t, 0.06, 0.24));
        r.lid.setAttribute('transform', `translate(0,${-14 * (1 - drop)})`);
        r.lid.setAttribute('opacity', seg(t, 0, 0.06) * (1 - ez(seg(t, 0.96, 1))) + ez(seg(t, 0.96, 1)) * 0);
        const co = seg(t, 0.28, 0.38) - ez(seg(t, 0.94, 1));
        r.clock.setAttribute('opacity', clamp(co, 0, 1));
        r.hand.setAttribute('transform', `rotate(${360 * ez(seg(t, 0.38, 0.88))},48,17)`);
      }
    },
    /* 2 — filled jar slides into fridge, door closes, snowflake pulses */
    chill: {
      dur: 5200,
      svg: bg => `
        <g ${G}>
          <rect x="15" y="7" width="26" height="48" rx="3"></rect>
          <line x1="17" y1="42" x2="39" y2="42"></line>
          <g id="jar2">
            <rect x="1.4" y="6.5" width="9.2" height="5" rx="1.4" fill="${BLUE}" stroke="none" opacity="0.85"></rect>
            <rect x="0" y="4" width="12" height="9" rx="2"></rect>
            <rect x="2.5" y="0" width="7" height="4" rx="1.2"></rect>
          </g>
          <g id="door">
            <rect id="doorRect" x="15" y="7" width="26" height="48" rx="3" fill="${bg}"></rect>
            <line id="handle" x1="37" y1="24" x2="37" y2="34"></line>
            <g id="flake" opacity="0">
              <line x1="28" y1="18.5" x2="28" y2="29.5"></line>
              <line x1="23.2" y1="21.2" x2="32.8" y2="26.8"></line>
              <line x1="32.8" y1="21.2" x2="23.2" y2="26.8"></line>
            </g>
          </g>
        </g>`,
      ids: ['jar2', 'door', 'doorRect', 'handle', 'flake'],
      update(r, t) {
        const slide = ez(seg(t, 0.04, 0.26));
        r.jar2.setAttribute('transform', `translate(${48 - 27 * slide},29)`);
        r.jar2.setAttribute('opacity', seg(t, 0, 0.04) - seg(t, 0.96, 1));
        const w = 26 * (ez(seg(t, 0.3, 0.44)) - ez(seg(t, 0.82, 0.94)));
        r.doorRect.setAttribute('width', Math.max(w, 0.01));
        r.door.setAttribute('opacity', clamp(w / 4, 0, 1));
        r.handle.setAttribute('x1', 15 + Math.max(w - 4, 2));
        r.handle.setAttribute('x2', 15 + Math.max(w - 4, 2));
        const p = seg(t, 0.5, 0.78);
        const pulse = (p > 0 && p < 1) ? Math.abs(Math.sin(p * Math.PI * 2)) : 0;
        r.flake.setAttribute('opacity', pulse);
        r.flake.setAttribute('transform', `translate(28,24) scale(${0.82 + 0.18 * pulse}) translate(-28,-24)`);
      }
    },
    /* 3 — shaker shakes, tips, pours into a shot glass */
    shake: {
      dur: 5000,
      svg: () => `
        <clipPath id="gc"><path d="M42.6,42 L44,53.4 L52,53.4 L53.4,42 Z"></path></clipPath>
        <rect id="gl" x="42" y="54" width="12" height="0" fill="${CHERRY}" opacity="0.9" clip-path="url(#gc)"></rect>
        <line id="stream2" x1="48" y1="28.5" x2="48" y2="41" stroke="${CHERRY}" stroke-width="2.2" stroke-linecap="round" opacity="0"></line>
        <g ${G}>
          <path d="M42,42 L43.5,54 L52.5,54 L54,42"></path>
          <g id="shaker">
            <path d="M-6,-8 L-8,13 Q-8,16 -5,16 L5,16 Q8,16 8,13 L6,-8 Z"></path>
            <path d="M-6,-8 L-4.5,-13 L4.5,-13 L6,-8 Z"></path>
            <rect x="-2.5" y="-16.5" width="5" height="3.5" rx="1.6"></rect>
          </g>
        </g>`,
      ids: ['gl', 'stream2', 'shaker'],
      update(r, t) {
        const p1 = seg(t, 0.02, 0.34);
        const env = (p1 > 0 && p1 < 1) ? Math.sin(p1 * Math.PI) : 0;
        const wob = Math.sin(p1 * Math.PI * 10) * 13 * env;
        const m = ez(seg(t, 0.36, 0.48)) - ez(seg(t, 0.76, 0.88));
        const x = 24 + 9 * m, y = 31 - 11 * m, a = wob + 115 * m;
        r.shaker.setAttribute('transform', `translate(${x},${y}) rotate(${a})`);
        const h = 9 * ez(seg(t, 0.5, 0.74));
        r.gl.setAttribute('y', 53.4 - h);
        r.gl.setAttribute('height', h + 1);
        r.gl.setAttribute('opacity', 0.9 * (1 - ez(seg(t, 0.96, 1))));
        r.stream2.setAttribute('opacity', (seg(t, 0.48, 0.53) - seg(t, 0.72, 0.77)) * m);
      }
    }
  };

  class VesperStepAnim extends HTMLElement {
    connectedCallback() {
      const scene = SCENES[this.getAttribute('kind')] || SCENES.fill;
      const bg = this.getAttribute('bg') || '#F2E4A8';
      const size = this.getAttribute('size') || 82;
      if (!this.shadowRoot) this.attachShadow({ mode: 'open' });
      this.shadowRoot.innerHTML = `<svg width="${size}" height="${size}" viewBox="0 0 64 64" aria-hidden="true" style="display:block">${scene.svg(bg)}</svg>`;
      const refs = {};
      scene.ids.forEach(id => { refs[id] = this.shadowRoot.getElementById(id); });
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { scene.update(refs, 0.58); return; }
      scene.update(refs, 0);
      const start = performance.now();
      const loop = now => {
        if (!this.isConnected) return;
        scene.update(refs, ((now - start) % scene.dur) / scene.dur);
        this._raf = requestAnimationFrame(loop);
      };
      this._raf = requestAnimationFrame(loop);
    }
    disconnectedCallback() { cancelAnimationFrame(this._raf); }
  }
  customElements.define('vesper-step-anim', VesperStepAnim);
})();
